import { Component, inject } from '@angular/core';
import { AppTitleService } from '../../services/app-title.service';

@Component({
    selector: 'app-seguimiento',
    imports: [],
    templateUrl: './seguimiento.component.html',
    styleUrl: './seguimiento.component.scss'
})
export class SeguimientoComponent {
  constructor() {
    inject(AppTitleService).setTitle('Seguimiento');
  }
}
